import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const headlines = [{
  text: 'They think you’re quiet. Really, you’re just "stuck." Here is the 7-day escape plan.',
  highlight: true
}, {
  text: 'The "Social Survival Script": How to handle 50 high-pressure English situations—even if your grammar is 60% wrong.',
  highlight: true
}, {
  text: 'Why your English teacher lied to you about "Small Talk."',
  highlight: false
}, {
  text: 'How to "buy time" in any conversation without looking lost.',
  highlight: false
}, {
  text: 'The secret to being the funniest person in the room (in your 2nd language).',
  highlight: false
}, {
  text: 'Beyond "Hello": The art of social chemistry for immigrants.',
  highlight: false
}, {
  text: 'The 3-second rule to stop the "English Freeze."',
  highlight: false
}, {
  text: 'Stop studying grammar. Start owning the room.',
  highlight: true
}, {
  text: 'The 7-Day Social Reset for ESL Professionals.',
  highlight: false
}, {
  text: 'Negotiate, Joke, and Connect: The Survival Blueprint.',
  highlight: false
}, {
  text: 'Your "Accent" isn\'t the problem. Your "Scripts" are.',
  highlight: true
}, {
  text: 'From "Invisible" to "In Demand": The Social Survival Hack.',
  highlight: false
}, {
  text: 'The 50 Situations that make or break your life abroad.',
  highlight: false
}, {
  text: 'Reclaim your dignity in English-speaking environments.',
  highlight: true
}];
export function HeadlineStackSection() {
  return <section className="py-20 bg-background border-y border-border relative overflow-hidden" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
        <div className="text-center mb-12" data-id="element-61">
          <h2 className="font-heading text-4xl md:text-5xl text-primary mb-4" data-id="element-62">
            DOES THIS SOUND{' '}
            <span className="text-accent-yellow" data-id="element-63">FAMILIAR?</span>
          </h2>
          <p className="text-muted text-lg max-w-2xl mx-auto" data-id="element-64">
            If you've ever felt trapped inside a language barrier, you know
            exactly what we're talking about.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-65">
          {headlines.map((item, index) => <div key={index} className={`p-6 rounded-xl border transition-all duration-300 hover:border-accent-yellow/50 group ${item.highlight ? 'bg-surface border-accent-yellow/20 shadow-[0_0_20px_-10px_rgba(245,200,66,0.1)]' : 'bg-background border-border'}`} data-id="element-66">
              <div className="flex items-start gap-3" data-id="element-67">
                <CheckCircle2 className={`w-5 h-5 mt-1 flex-shrink-0 ${item.highlight ? 'text-accent-yellow' : 'text-muted group-hover:text-accent-yellow/70'}`} data-id="element-68" />
                <p className={`text-lg font-medium leading-snug ${item.highlight ? 'text-primary' : 'text-muted group-hover:text-primary/80'}`} data-id="element-69">
                  {item.text}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}